// import TweenLite from './vendor/TweenLite';
// import { qs, qsArray } from './utilities/selectors';
import { qs, qsArray, isInternetExplorer, isEdge, trackEvent } from "./utilities/index"
import Application from "./application"
import Overlay from "./overlay"



let Question = function (params) {
	// console.log('Question initalizing ' + params);

	/**
	 *
	 */
	let self = this
	let elementId = params.elementId
	let QuestionElement = document.getElementById(params.elementId)
	// 'multiple-choice' or 'range-slider'
	let type = QuestionElement.getAttribute("data-question-type")
	let background = QuestionElement.querySelector(".bg-image")
	let text = QuestionElement.querySelector(".question-wrap")
	let importantButton = QuestionElement.querySelector(".btn-important")
	let contentImage = QuestionElement.querySelector(".content-image")
	let controls = QuestionElement.querySelector(".controls")
	let answers = qsArray(".answer", QuestionElement)
	let slider = QuestionElement.querySelector(".slider")
	let dropdown = QuestionElement.querySelector(".question-dropdowns select")
	let checkboxes = QuestionElement.querySelectorAll('.question input[type="checkbox"]')
	let nextButton = QuestionElement.querySelector(".next-button")
	let timeline
	let selectedAnswerId = ""
	let selectedAnswerValue = ""
	let selectedDirection = 0
	let sliderTween1 = null
	let sliderTween2 = null
	let sliderTween3 = null
	let question5Scores = [200, 211, 221, 231, 241, 251, 261, 271, 281, 291, 300]

	let overlay = new Overlay()
	// console.log('answers is ' + answers);
	// console.log('slider is ' + slider);
	// console.log('question type is ' + type);

	this.open = function () {
		// console.log('Question.open');
		window.resizeFrame();
		window.driverSelector.fillProgressBar()
		TweenLite.set([background, text, controls], { opacity: 0 })
		TweenLite.set(answers, { opacity: 0 })
		if (contentImage !== null) {
			TweenLite.set(contentImage, { opacity: 0 })
		}
		if (slider !== null) {
			TweenLite.set(slider, { opacity: 0 })
		}
		QuestionElement.style.display = "block"
		timeline = new TimelineLite({ onComplete: this.openComplete, onCompleteScope: this })
		timeline.to(background, Application.tweenLength, { opacity: 1 })
		timeline.to(text, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		if (contentImage !== null) {
			timeline.to(contentImage, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		}
		for (let x = 0; x < answers.length; x++) {
			timeline.to(answers[x], Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		}
		if (slider !== null) {
			timeline.to(slider, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		}
		timeline.to(controls, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		timeline.play()
	}

	this.openComplete = function () {
		if (type === "multiple-choice") {
			this.initialzeImportantButton()
			this.initializeAnswers()
			//this.initializePreviousButton()
			// this.initializeNextButton();
			if (selectedAnswerId !== "") {
				this.initializeNextButton()
			}
		} else if (type === "range-slider") {
			this.initialzeImportantButton()
			this.initializeSlider()
			//this.initializePreviousButton()
			this.initializeNextButton()
		} else if (type === "dropdown") {
			this.initialzeImportantButton()
			this.initializeDropDown()
		} else if (type === "brand-selector") {
			this.initialzeImportantButton()
			this.initializeBrandDropDowns()
		} else if (type === "shaft-details") {
			this.initialzeImportantButton()
			this.initializeShaftDropDowns()
		} else if (type === "handicap") {
			this.initialzeImportantButton()
			this.initializeHandicap()
		} else if (type === "checkboxes") {
			this.initialzeImportantButton()
			this.initializeCheckboxes()
		}
		
    }

	this.initializeAnswers = function () {
		// console.log('init answers ' + this.answerClicked);
		let answer
		for (let x = 0; x < answers.length; x++) {
			answer = answers[x]
			answer.addEventListener("click", this.answerClicked)
		}

		//if we return to a question with a selected answer, enable next
		if (QuestionElement.querySelector('.answer.selected')) {
			self.initializeNextButton()
		}
		// console.log('question has ' + answers.length + ' answers');
	}

	this.disableAnswers = function () {
		let answer
		for (let x = 0; x < answers.length; x++) {
			answer = answers[x]
			answer.removeEventListener("click", this.answerClicked)
		}
	}
	
	this.initializeSlider = function () {
		if (slider !== null) {
			this.input = slider.querySelector("input")
			this.value = slider.querySelector(".value")
			
			if (isInternetExplorer() === true) {
				// chrome slider released, works in ie
				this.input.addEventListener("change", this.sliderChanged)
			} else {
				// chrome slider moved, doesn't work in ie works in edge and everything else
				this.input.addEventListener("input", this.sliderChanged)
			}

			if (elementId !== "question-2") {
				this.sliderImage1 = QuestionElement.querySelector(".slider-image-1")
				this.sliderImage2 = QuestionElement.querySelector(".slider-image-2")
				this.sliderImage3 = QuestionElement.querySelector(".slider-image-3")
			}

			self.sliderChanged();
			self.initializeNextButton();

			let tooltip = slider.querySelector(".tooltip");

			const distanceRadios = QuestionElement.querySelectorAll('input[name="distance-units"]');
			const numberLabels = QuestionElement.querySelectorAll('.distance-slider .node-list .node, .distance-slider .number-label-list .number-label');

			// Add an event listener to each radio button
			distanceRadios.forEach(radio => {
				radio.addEventListener('change', function() {
					// 'this' refers to the radio button that was just changed
					self.sliderUpdateDisplay();
					if(this.value == 'yards') {
						QuestionElement.querySelector('.number-label-list').classList.add('yards');
						QuestionElement.querySelector('.number-label-list').classList.remove('meters');
					} else {
						QuestionElement.querySelector('.number-label-list').classList.add('meters');
						QuestionElement.querySelector('.number-label-list').classList.remove('yards');
					}
				});
			});

			numberLabels.forEach(lbl => {
				lbl.addEventListener('click', function () {
					let min = parseInt(self.input.getAttribute('min'));
					self.input.value = min + (25 * parseInt(this.getAttribute('data-value')));
					self.sliderChanged();
				});
			});

			if (tooltip) {
				let isDragging = false;
				let startX;
				let initialLeft;

				function handleMove(deltaX) {
					let newLeft = initialLeft + deltaX;

					// Get container and draggable dimensions
					const containerRect = tooltip.parentElement.getBoundingClientRect();
					const draggableRect = tooltip.getBoundingClientRect();

					// Calculate the maximum allowed left position
					//const maxLeft = containerRect.width - draggableRect.width;
					//console.log('containerRect.width=' + containerRect.width + ' draggableRect.width=' + draggableRect.width)
					const maxLeft = containerRect.width;
					// Constrain the newLeft within the container's bounds
					console.log('newLeft=' + newLeft + ' maxLeft=' + maxLeft)
					newLeft = Math.max(0, Math.min(newLeft, maxLeft));

					tooltip.style.left = `${newLeft}px`;

					let tempVal = (newLeft / maxLeft) * 100;
					console.log('tempVal=' + tempVal)
					let newVal = (Math.round(tempVal / 5) * 5) + 100;
					console.log('newVal=' + newVal)
					self.input.value = newVal;
					self.sliderUpdateDisplay();
				}

				tooltip.addEventListener('mousedown', (e) => {
					isDragging = true;
					tooltip.classList.add('dragging');
					startX = e.clientX; // Get the initial mouse X position
					initialLeft = tooltip.offsetLeft; // Get the initial left position of the draggable element
				});

				document.addEventListener('mousemove', (e) => {
					if (!isDragging) return;

					// Calculate the new horizontal position based on mouse movement
					const deltaX = e.clientX - startX;
					handleMove(deltaX);
				});

				document.addEventListener('mouseup', () => {
					isDragging = false;
					tooltip.classList.remove('dragging');
				});

				// Handle touch events for mobile devices
				tooltip.addEventListener('touchstart', (e) => {
					isDragging = true;
					tooltip.classList.add('dragging');
					startX = e.touches[0].clientX;
					initialLeft = tooltip.offsetLeft;
				});

				document.addEventListener('touchmove', (e) => {
					if (!isDragging) return;
					const deltaX = e.touches[0].clientX - startX;
					handleMove(deltaX);
				});

				document.addEventListener('touchend', () => {
					isDragging = false;
					tooltip.classList.remove('dragging');
				});
			}
		}
	}

	this.sliderUpdateDisplay = function () {

		var rangeAmount = self.input.max - self.input.min;
		var ratio = ((self.input.value - self.input.min) / rangeAmount);
		var percentage = ratio * 100;
		var tooltip = QuestionElement.querySelector('.tooltip');
		if (tooltip) {
			let containerWid = tooltip.parentElement.clientWidth;
			let tooltipPos = containerWid * ratio;
			
			//if (ratio < 0.5) {
			//	tooltipPos += 8 - (8 * ratio);
			//} else if (ratio > 0.5) {
			//	tooltipPos -= 8 * ratio;;
			//}

			let distanceUnits = QuestionElement.querySelector('input[name="distance-units"]:checked');
			var distanceDisplay = self.input.value;

			if (distanceUnits && distanceUnits.value == 'meters') {
				distanceDisplay = Math.round(distanceDisplay * 0.9144);
			}

			
			QuestionElement.querySelector('.tooltip').innerHTML = distanceDisplay;
			QuestionElement.querySelector('.tooltip').style.left = tooltipPos + 'px';
		}

		var fill = QuestionElement.querySelector('.track .fill');
		if (fill) {
			fill.style.width = percentage + '%';
		}

		//slider.style.setProperty('--range-value', percentage + '%');

		if (QuestionElement.querySelectorAll('.number-label').length > 0) {
			QuestionElement.querySelectorAll('.number-label').forEach((elem) => elem.classList.remove('active'));
			if (percentage >= 100) {
				QuestionElement.querySelectorAll('.node-2,.node-3,.node-4,.node-5').forEach((elem) => elem.classList.add('active'));
				if (percentage == 100) {
					QuestionElement.querySelector('.number-label-5').classList.add('active');
				}
			}
			else if (percentage >= 75) {
				QuestionElement.querySelectorAll('.node-2,.node-3,.node-4').forEach((elem) => elem.classList.add('active'));
				QuestionElement.querySelectorAll('.node-5').forEach((elem) => elem.classList.remove('active'));
				if (percentage == 75) {
					QuestionElement.querySelector('.number-label-4').classList.add('active');
				}
			} else if (percentage >= 50) {
				QuestionElement.querySelectorAll('.node-2,.node-3').forEach((elem) => elem.classList.add('active'));
				QuestionElement.querySelectorAll('.node-4,.node-5').forEach((elem) => elem.classList.remove('active'));
				if (percentage == 50) {
					QuestionElement.querySelector('.number-label-3').classList.add('active');
				}
			} else if (percentage >= 25) {
				QuestionElement.querySelectorAll('.node-2').forEach((elem) => elem.classList.add('active'));
				QuestionElement.querySelectorAll('.node-3,.node-4,.node-5').forEach((elem) => elem.classList.remove('active'));
				if (percentage == 25) {
					QuestionElement.querySelector('.number-label-2').classList.add('active');
				}
			} else {
				QuestionElement.querySelectorAll('.node-2,.node-3,.node-4,.node-5').forEach((elem) => elem.classList.remove('active'));
				if (percentage == 0) {
					QuestionElement.querySelector('.number-label-1').classList.add('active');
				}
			}
		}

		
		if (QuestionElement.querySelectorAll('.meter-line').length > 0) {
			
			QuestionElement.querySelectorAll('.meter-line ').forEach((elem) => elem.classList.remove('active'));
			QuestionElement.querySelectorAll('.meter-line')[self.input.value].classList.add('active');
		}


	}

	this.sliderChanged = function () {
		console.log("changed: " + elementId)
		self.sliderUpdateDisplay();

		//swap images for other sliders
		let index = self.input.value
		let tweenLength = 0.1
		let delayLength = 0
		if (sliderTween1 !== null) {
			sliderTween1.kill()
			sliderTween2.kill()
			sliderTween3.kill()
			sliderTween1 = null
			sliderTween2 = null
			sliderTween3 = null
		}
			// question 4 is full fade to black
		if (elementId === "question-6" || elementId === "question-10" || elementId === "question-11") {

			// question 5 and 6 is crossfade
			// console.log('show slider image ' + index);
			if (index < 4) {
				sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 1 })
				sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 0 })
				sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 0 })
			} else if (index >= 4 && index <= 6) {
				sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 0 })
				sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 1 })
				sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 0 })
			} else if (index > 6) {
				sliderTween1 = TweenLite.to(self.sliderImage1, tweenLength, { opacity: 0 })
				sliderTween2 = TweenLite.to(self.sliderImage2, tweenLength, { opacity: 0 })
				sliderTween3 = TweenLite.to(self.sliderImage3, tweenLength, { opacity: 1 })
			}

		}
	}



	this.initializeDropDown = function () {
		if (dropdown == null) {
			return;
		}

		if (dropdown.value != 'default') {
			selectedAnswerId = dropdown.value;
			self.initializeNextButton();
		}

		dropdown.parentNode.classList.add('is-active');
		dropdown.parentNode.classList.add('is-visible');

		dropdown.addEventListener('change', function () {
			// console.log(dropdownA.value);
			let value = dropdown.value;
			if (value != 'default') {
				selectedAnswerId = value;
				self.initializeNextButton();
			} else {
				self.disableControls();
			}
		});
	}

	this.initializeBrandDropDowns = function  () {
		let dropdownA = qs('#brand-select', QuestionElement);
		let dropdownB = qs('#loft-select', QuestionElement);
		
		checkDropdownValues();

		dropdownA.addEventListener('change', function() {
			checkDropdownValues();
		});
		dropdownB.addEventListener('change', function() {
			checkDropdownValues();
		});

		function checkDropdownValues() {
			if(dropdownA.value != 'default' && dropdownB.value != 'default') {
				self.initializeNextButton()
			}	
		}
	}

	this.initializeShaftDropDowns = function  () {
		let dropdownA = qs('#shaft-select', QuestionElement);
		let dropdownB = qs('#flex-select', QuestionElement);
		let dropdownC = qs('#shaft-weight-select', QuestionElement);
		
		checkDropdownValues();

		dropdownA.addEventListener('change', function() {
			checkDropdownValues();
		});
		dropdownB.addEventListener('change', function() {
			checkDropdownValues();
		});
		dropdownC.addEventListener('change', function() {
			checkDropdownValues();
		});

		function checkDropdownValues() {
			if(dropdownA.value != 'default' && dropdownB.value != 'default' && dropdownC.value != 'default') {
				self.initializeNextButton()
			}	
		}
	}



	this.initializeHandicap = function () {
		let btnIncrement = QuestionElement.querySelector('.btn-increment');
		let btnDecrement = QuestionElement.querySelector('.btn-decrement');
		let handicapInput = QuestionElement.querySelector('#handicap-input');
		let avgscoreInput = QuestionElement.querySelector('#avgscore-input');
		let handicapMode = QuestionElement.querySelectorAll('input[name="score-mode"]');
		let numberDisplay = QuestionElement.querySelector('.number-display');
		let textInput = null;
		let selected = QuestionElement.querySelector('input[name="score-mode"]:checked');
		if (selected.value == 'avgscore') {
			textInput = avgscoreInput;
		} else {
			textInput = handicapInput;
		}
		numberDisplay.innerHTML = textInput.value;
		this.initializeNextButton()

		if (typeof window.handicapBound == 'undefined' || !window.handicapBound) {
			btnIncrement.addEventListener("click", incrementClick);
			btnDecrement.addEventListener("click", decrementClick);
			window.handicapBound = true;
		}

		function incrementClick() {
			let textInput = null;
			let selected = QuestionElement.querySelector('input[name="score-mode"]:checked');
			if (selected.value == 'avgscore') {
				textInput = avgscoreInput;
			} else {
				textInput = handicapInput;
			}

			let val = textInput.value;
			val++;
			textInput.value = val;
			numberDisplay.innerHTML = val;
		}

		function decrementClick() {
			let textInput = null;
			let selected = QuestionElement.querySelector('input[name="score-mode"]:checked');
			if (selected.value == 'avgscore') {
				textInput = avgscoreInput;
			} else {
				textInput = handicapInput;
			}

			let val = textInput.value;
			val--;
			textInput.value = val;
			numberDisplay.innerHTML = val;
		}

		handicapMode.forEach(radio => {
			radio.addEventListener("change", function (evt) {
				let selected = QuestionElement.querySelector('input[name="score-mode"]:checked');
				if (selected.value == 'avgscore') {
					numberDisplay.innerHTML = avgscoreInput.value;
				} else {
					numberDisplay.innerHTML = handicapInput.value;
				}
			});
		});

	}

	this.initializeCheckboxes = function () {

		self.disableControls();
		if (QuestionElement.querySelectorAll('input[type="checkbox"]:checked').length > 0) {
			self.initializeNextButton();
		}

		QuestionElement.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
			checkbox.addEventListener('change', function (evt) {

				if (evt.target.checked) {
					self.initializeNextButton();
				}
			});
		});
	}

	this.initialzeImportantButton = function () {
		if (importantButton !== null) {
			// console.log('enable important button');
			importantButton.addEventListener("click", this.importantButtonClicked)
		}
	}

	this.initializePreviousButton = function () {
		// console.log('init previous button ' + previousButton);
		previousButton.addEventListener("click", this.previousClicked)
	}

	this.initializeNextButton = function () {
		// console.log('init next button ' + nextButton);
		nextButton.addEventListener("click", this.nextClicked)
		nextButton.classList.remove("disabled")
		// nextButton.classList.add('enabled');
	}

	this.disableControls = function () {
		
		nextButton.classList.add("disabled")
		nextButton.removeEventListener("click", this.nextClicked)
	}

	this.answerClicked = function (event) {
		// console.log('Question.answerClicked ' + event.target.id);
		// console.log('selected answer id was ' + self.selectedAnswerId);
		if (selectedAnswerId === "") {
			self.initializeNextButton()
		}
		self.resetAnswers()
		// if its multiple choice set values here, if its slider set it in nextClicked
		const parentButton = event.target.closest('button');
		selectedAnswerId = parentButton.id
		selectedAnswerValue = parentButton.getAttribute('data-value');
		parentButton.classList.add("selected")
		// console.log('now selected answer id is ' + self.selectedAnswerId);
		
	}

	this.resetAnswers = function () {
		let answer
		for (let x = 0; x < answers.length; x++) {
			answer = answers[x]
			answer.classList.remove("selected")
		}
		selectedAnswerId = ""
		selectedAnswerValue = ""
	}

	this.resetSliders = function () {
		document.querySelectorAll('input[type="range"]').forEach(function (slider) {
			slider.value = slider.getAttribute('data-default-value');
		});
	}

	this.resetHandicap = function () {
		let handicapInput = document.querySelector('#handicap-input');
		let avgscoreInput = document.querySelector('#avgscore-input');
		let handicapDefault = document.querySelector('#handicap-default');
		let avgscoreDefault = document.querySelector('#avgscore-default');

		let scoreMode = document.querySelectorAll('input[name="score-mode"]');
		let numberDisplay = document.querySelector('.number-display');

		scoreMode[0].checked = true;
		avgscoreInput.value = avgscoreDefault.value;
		handicapInput.value = handicapDefault.value;
		numberDisplay.innerHTML = handicapInput.value;

	}

	this.resetDropdowns = function () {
		document.querySelectorAll('select').forEach(function (sel) {
			sel.selectedIndex = 0;
		});
	}

	this.reset = function () {
		this.resetAnswers()
		this.resetSliders()
		this.resetDropdowns()
		this.resetHandicap()

		overlay.closeImportantWindow()
	}

	this.importantButtonClicked = function () {
		overlay.openImportantWindow(elementId)
	}

	this.previousClicked = function (event) {
		// console.log('Question.previousClicked ' + event.target.id);
		self.selectedDirection = -1
		self.close();
		
		// window.driverSelector.questionClosed(-1);
		trackEvent("navigation", "Previous")
	}

	this.nextClicked = function (event) {
		// console.log('Question.previousClicked ' + event.target.id);
		self.selectedDirection = 1
		let currentScore = -1;
		let answerText = '';

		answerText = selectedAnswerValue;
		let rangeInput = QuestionElement.querySelector('input[type="range"]');
		
		if (elementId == 'question-5') {
			let distance = self.input.value;
			answerText = distance;
			for (let y = 0; y < question5Scores.length; y++) {
				if (distance >= question5Scores[y]) {
					currentScore = y;
				}
			}
		}

		if (elementId == 'question-6' || elementId == 'question-7' || elementId == 'question-8' || elementId == 'question-9') {
			currentScore = self.input.value;
			answerText = currentScore;
		}

		if (currentScore >= 0) {
			window.driverSelector.applyScore(elementId, currentScore);
		}

		if (elementId == 'question-1') {
			window.driverSelector.setHandedness(answerText)
		}

		if (elementId == 'question-3') {
			let loftSelect = QuestionElement.querySelector('select[name="loft-select"]');
			window.driverSelector.setLoft(loftSelect.value)
		}

		// close it up
		self.close()

		if (answerText) {
			trackEvent("answer", elementId, answerText)
		}
		trackEvent("navigation", "Next")
	}

	self.getCheckboxValue = function (fieldname) {
		let checkbox = QuestionElement.querySelector('input[name="' + fieldname + '"]');
		if (checkbox.checked) {
			return parseInt(checkbox.value);
		}

		return 0;
	}

	this.close = function () {
		// console.log('close ' + selectedAnswerId);
		this.disableAnswers()
		this.disableControls()
		window.driverSelector.fillProgressBar()
		timeline.kill()
		timeline = new TimelineLite({ onComplete: closeComplete, onCompleteScope: this })
		timeline.to(controls, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		for (let x = answers.length - 1; x >= 0; x--) {
			timeline.to(answers[x], Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		}
		if (slider !== null) {
			timeline.to(slider, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		}
		if (contentImage != null) {
			timeline.to(contentImage, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		}
		timeline.to(text, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		timeline.to(background, Application.tweenLength, { opacity: 0 })
		timeline.timeScale(2)
		timeline.play()
	}

	function closeComplete() {
		// console.log('closeComplete ' + this.selectedDirection);
		timeline.kill()
		timeline = null
		// content.style.display = 'none';
		QuestionElement.style.display = "none"
		window.driverSelector.questionClosed(this.selectedDirection)
	}

}

export default Question
